<template>
  <div class="mb-3">
    <analyst-form
      v-if="data"
      ref="form"
      :analyst="analyst"
      @save-success="saveSuccess"
    />
    <div class="d-flex w-100 border-top pt-4">
      <button
        class="btn btn-outline-danger"
        @click="$modal.show('confirm-delete')"
      >
        Delete analyst
      </button>
      <button
        class="ml-auto btn btn-primary "
        type="button"
        @click="$refs.form.save()"
      >
        Save
      </button>
    </div>
    <confirm
      v-if="analyst"
      @confirmed="deleteAnalyst"
      :name="analyst.name"
    />
  </div>
</template>

<script>
import AnalystForm from './Form'
import Confirm from '@/components/Confirm'
import {successNotification} from '@/notifications'

export default {
  components: {
    AnalystForm,
    Confirm,
  },
  metaInfo () {
    return {
      title: this.analyst && this.analyst.name ? this.analyst.name : 'Edit Analyst',
    }
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  watch: {
    data () {
      this.setAnalyst()
    },
  },
  data () {
    return {
      analyst: null,
    }
  },
  beforeMount () {
    this.setAnalyst()
  },
  methods: {
    setAnalyst () {
      this.analyst = Object.assign({}, this.data)
    },
    saveSuccess (response) {
      this.$notify(successNotification())
    },
    deleteAnalyst () {
      this.$http.delete(`/analysts/${this.analyst.id}`)
          .then(() => {
            this.$notify(successNotification(`Removed analyst ${this.analyst.name}`))
            this.$router.replace({name: 'analysts', hash: '#fresh'})
          })
    },
  },
}
</script>
